module.exports = __webpack_public_path__ + "img/friss-marker.8571c247.png";